module.exports = __webpack_public_path__ + "img/intro3.fc209d9b.png";